// @ts-nocheck
import React from 'react';
import logo from 'assets/img/login-logo.png';
import {
  Box,
  ThemeProvider,
  Typography,
  Stack,
  Card,
  CardContent,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { createModifiedTheme } from '../Theme';
import { useClientStyles } from '../Styles';
import useStatusConfirm from '../hooks/useStatusConfirm';

const emailExternalTheme = createModifiedTheme();

const LinkExpired = () => {
  const classes = useClientStyles();
  const { clientMessage } = useStatusConfirm();

  return (
    <ThemeProvider theme={emailExternalTheme}>
      <Box className={classes.root}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          className={classes.stack}
          px={2}
          py={2}
        >
          <Box sx={{ width: '164px' }}>
            <img className="logo" src={logo} alt="Logo" />
          </Box>
          <Card
            sx={{
              maxWidth: 500,
            }}
            mt={2}
          >
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <InfoOutlinedIcon
                  style={{ color: emailExternalTheme.palette.secondary.main }}
                  fontSize="large"
                />
                <Typography variant="subtitle2" color="white">
                  {clientMessage}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </ThemeProvider>
  );
};

export default LinkExpired;
